module.exports = __webpack_public_path__ + "static/AllTopSVGs-91672bd566cf802b0465120f6a22f444.svg";